import { render, staticRenderFns } from "./BindWechat.vue?vue&type=template&id=19566b2d&scoped=true"
import script from "./BindWechat.vue?vue&type=script&lang=js"
export * from "./BindWechat.vue?vue&type=script&lang=js"
import style0 from "./BindWechat.vue?vue&type=style&index=0&id=19566b2d&prod&lang=scss&scoped=true"
import style1 from "./BindWechat.vue?vue&type=style&index=1&id=19566b2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19566b2d",
  null
  
)

export default component.exports